module.exports = __webpack_public_path__ + "media/icons/pochodzenie-sprowadzony-white@2x-544fae0b.png";